<template>
  <div>
    <!-- Menu Quick Orders Toolbar-->
    <v-list v-if="toolbar" color="secondary" class="quick-order-container">
      <br />

      <v-list-item v-for="(product, index) in quickOrder" :key="index">
        <v-container class="pa-0">
          <div class="form-inline">
            <v-text-field
              placeholder="Artículo #"
              @blur="checkProduct(product)"
              @paste="onPaste()"
              v-model="product.itemSku"
              :value="product.itemSku"
              solo
              dense
              class="order-art p-0"
            >
            </v-text-field>

            <v-text-field
              v-model="product.quantity"
              :value="product.quantity"
              @keypress="allowOnlyNumbers"
              placeholder="Cant."
              solo
              dense
              class="order-cant p-0"
              type="text"
            >
            </v-text-field>

            <div class="pl-2">
              <v-btn
                color="#dd0000"
                class="px-0 removeItem"
                @click="removeLine(quickOrder, index)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
          </div>

          <div v-if="product.validation">
            <v-alert
              dense
              border="right"
              class="mb-0"
              colored-border
              type="error"
            >
              Producto no encontrado
            </v-alert>
          </div>
        </v-container>
      </v-list-item>

      <!-- Botón para agregar las lineas a la lista -->
      <v-list-item>
        <v-row justify="center" class="pa-5 pl-3 rp-4">
          <v-btn @click="addLine(quickOrder)" dense class="add-line pl-4">
            <v-icon>add</v-icon> Líneas
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            @click="agregarProductosCarrito(quickOrder)"
            color="#fd6c17"
            dense
            class="add-order pr-4"
          >
            Agregar a Lista
          </v-btn>
        </v-row>
      </v-list-item>

      <!-- boton que lleva a quickOrder -->
      <v-list-item>
        <v-row justify="center" class="pt-6 pb-6 pl-3 rp-4">
          <v-btn small color="primary" href="#/list" class="more-lines" dense>
            Ir a lista
          </v-btn>
        </v-row>
      </v-list-item>
    </v-list>

    <!-- Menu Quick Orders Boton ListaRapida-->
    <v-list v-if="!toolbar" color="secondary">
      <v-list-item>
        <v-row justify="center" class="pa-1 pl-3 pr-3">
          <v-spacer></v-spacer>

          <v-btn @click="addLine(quickOrder)" dense class="add-line pl-4">
            <v-icon>add</v-icon> Líneas
          </v-btn>
        </v-row>
      </v-list-item>

      <v-list-item v-for="(product, index) in quickOrder" :key="index">
        <v-container class="pa-0">
          <div class="form-inline">
            <v-text-field
              placeholder="Articulo #"
              @blur="checkProduct(product)"
              @paste="onPaste()"
              v-model="product.itemSku"
              :value="product.itemSku"
              solo
              dense
              class="order-art-qo p-0"
            >
            </v-text-field>

            <v-text-field
              v-model="product.quantity"
              :value="product.quantity"
              placeholder="Cant."
              solo
              dense
              class="order-cant-qo p-0"
              type="number"
              min="0"
            >
            </v-text-field>

            <div class="pl-2">
              <v-btn
                color="#dd0000"
                class="px-0 removeItem"
                @click="removeLine(quickOrder, index)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
          </div>

          <div v-if="product.validation">
            <v-alert
              dense
              border="right"
              class="mb-0"
              colored-border
              type="error"
            >
              Producto no encontrado
            </v-alert>
          </div>
        </v-container>
      </v-list-item>

      <!-- Botón para agregar las lineas a la lista -->
      <v-list-item>
        <v-row justify="center" class="pa-1 pl-3 pr-3">
          <v-spacer></v-spacer>
          <v-btn @click="addLine(quickOrder)" dense class="add-line pr-4 mr-4">
            <v-icon>add</v-icon> Líneas
          </v-btn>

          <v-btn
            @click="agregarProductosCarrito(quickOrder)"
            color="#fd6c17"
            dense
            class="add-order pl4"
          >
            Agregar a Lista
          </v-btn>
        </v-row>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import _ from "underscore";
import { addProductCart } from "./../../utils/shoppingCart";

export default {
  name: "quickOrderListItems",

  components: {},

  data() {
    return {
      // item => sku
      quickOrder: [
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
      ],
      defaultQuickOrder: [
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
      ],
      defaultItem: {
        itemSku: "",
        quantity: "",
        product: null,
        validation: false,
      },
    };
  },

  props: {
    actualizarContadores: Function,
    updateShopingQuantity: Function,
    snackbar: Function,
    toolbar: Boolean,
  },

  methods: {
    onPaste: async function () {
      const data = await navigator.clipboard.readText();
      const rowStrArray = data.split("\r\n");
      var rows = rowStrArray.map((row) => {
        let Row = row.split("\t");
        let quantity = Row[1] > 0 ? Row[1] : !!Row[0] ? 1 : "";
        let object = {
          itemSku: Row[0],
          quantity,
          product: null,
          validation: false,
        };
        this.checkProduct(object);
        return object;
      });
      this.quickOrder = rows;
    },

    addLine: function (list) {
      list.push({
        itemSku: "",
        quantity: "",
        product: null,
        validation: false,
      });
    },

    removeLine: function (list, index) {
      list.splice(index, 1);
    },

    updateQuantity: function () {
      this.updateShopingQuantity();
      this.quickOrder = [
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
        { itemSku: "", quantity: "", product: null, validation: false },
      ];
    },

    allowOnlyNumbers(event) {
      const key = event.key;
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    },

    checkProduct: function (product) {
      var vm = this;
      if (product.itemSku != "")
        this.$http.get(`product/sku/` + product.itemSku).then(
          (response) => {
            var list = response.body.data;
            if (response.body.data) product.product = response.body.data;
            else {
              product.product = null;
              vm.snackbar(
                `No se encontro producto con el codigo  \" ${product.itemSku} \"`
              );
            }

            product.validation = !list && !!product.product ? true : false;

            this.loading = false;
          },
          (error) => {
            product.validation = true;
            product.product = null;
            this.snackbar(
              error.message ||
                `No se encontro producto con el codigo  \" ${product.itemSku} \"`
            );
            // console.error(error);
          }
        );
      else {
        product.product = null;
      }
    },

    agregarProductosCarrito: function (list) {
      var vm = this;
      var isAtLeastProduct = false;
      list.map(function (item, index) {
        if (item.product) {
          isAtLeastProduct = true;
          vm.agregarProductoCarrito(item, index);
        }
      });
      if (!isAtLeastProduct) {
        this.snackbar("Ingrese por lo menos un código de producto valido");
      } else {
        this.updateQuantity();
        if (!this.toolbar) this.actualizarContadores();
      }
    },

    agregarProductoCarrito: function (item, index) {
      var defaultItem = this.defaultItem;
      if (item.product.itemId) {
        var producto = {
          id: item.product.id,
          image: item.product.image,
          itemId: item.product.itemId,
          description: item.product.description,
          code: item.product.code,
          providerCode: item.product.providerCode,
          quantity: parseInt(item.quantity),
        };
        if (this.verification()) {
          addProductCart(producto);
          this.quickOrder[index] = defaultItem;
          this.snackbar("Producto agregado exitosamente");
        }
      }
    },

    verification: function () {
      var list = this.quickOrder;
      if (_.where(list, { validation: true }).length == 0) {
        if (this.productQuantityVerification(list)) {
          return true;
        } else {
          this.snackbar("Ingrese una cantidad válida.");
          return false;
        }
      } else {
        this.snackbar("Ingrese productos válidos.");
        return false;
      }
    },

    productQuantityVerification(list) {
      var quantityVerification = _.filter(list, function (item) {
        return item.product != null && item.quantity > 0;
      });
      return quantityVerification.length > 0;
    },

    resetObject(defaultQuickOrder) {
      this.quickOrder = defaultQuickOrder;
    },
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style scoped>
.quick-order-container {
  width: 32rem;
}
.add-line {
  background-color: #fd6c17 !important;
  color: white;
  width: 13.58rem;
}
.add-order {
  color: white;
  width: 13.181rem;
}
.more-lines {
  color: white;
  width: 28.3rem;
}
.order-art {
  height: 20px !important;
  width: 12rem;
}
.order-cant {
  width: 8rem;
  margin-left: 5%;
  height: 20px !important;
}
.order-art-qo {
  height: 20px !important;
  width: 18rem;
}
.order-cant-qo {
  width: 4rem;
  margin-left: 5%;
  height: 20px !important;
}
.removeItem {
  /* background-color: #c50e00!important; */
  color: white;
  height: 3.8rem !important;
  width: 3.8rem !important;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  padding: 8px 0;
  /* align-items: center; */
}
.rp-4 {
  padding-right: 18px !important;
}
</style>
<style lang="scss">
.v-btn {
  min-width: 36px !important;
}
</style>
